import { getPaymentLinkPlanPriceStatus } from 'actions/generatePaymentLink';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
interface GeneratedLinkPaymentProps {
  paymentToken: string;
}

const GeneratedLinkPayment: React.FC<GeneratedLinkPaymentProps> = ({
  paymentToken,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const paymentTokenFromState = (
    history.location.state as { paymentToken?: string } | undefined
  )?.paymentToken;
  const paymentTokenValue = paymentToken || paymentTokenFromState;

  useEffect(() => {
    const fetchData = async () => {
      if (!paymentTokenValue) {
        setIsLoading(false);
        history.replace('/expiredLink');
        return;
      }
      try {
        const { data, status } = await getPaymentLinkPlanPriceStatus(
          paymentTokenValue
        );
        if (status === 200) {
          history.replace(`/pay/${paymentTokenValue}/plan`, {
            paymentPlanData: data,
            fromPayment: true,
          });
        } else {
          history.replace('/expiredLink');
        }
      } catch {
        history.replace('/expiredLink');
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [history, paymentToken, paymentTokenValue]);

  return <div>{isLoading && <p>Loading...</p>}</div>;
};

export default GeneratedLinkPayment;
